import { config } from "../../config"

export const fetchReadingLanguages = async (
    token: string
): Promise<string[]> => {
    try {
        const res = await fetch(`${config.api.urlV1}/feed/language/`, {
            method: 'GET',
            headers: {
                token,
                'Content-type': 'application/json',
            },
        })

        if (res.status !== 200) {
            const body = await res.json()

            console.log(body)

            return []
        }

        return (await res.json()).languages
    } catch (e) {
        console.log(e)
        return []
    }
}

export const updateReadingLanguages = async (
    languages: string[],
    token: string
): Promise<void> => {
    try {
        await fetch(`${config.api.urlV1}/feed/language/`, {
            method: 'PATCH',
            headers: {
                token,
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                languages,
            })
        })
    } catch (e) {
        console.log(e)
    }
}

